import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getProviders() {
        return Axios.get(`${baseURL}actor/staff/business/providers`).then(
            response => response.data.response
        );
    },
    getAllStaff() {
        return Axios.get(`${baseURL}actor/staff?getAll=1`).then(
            response => response.data.response
        );
    },
    getRoles() {
        return Axios.get(`${baseURL}actor/roles`).then(
            response => response.data.response
        );
    },
    updateReleaseNote(actorId, releaseNoteId) {
        let params = {
            actor_id: actorId,
            release_note_id: releaseNoteId
        };
        return Axios.put(`${baseURL}actor/release/note`, params).then(
            response => response
        );
    },
    getStaffList(params) {
        return Axios.get(`${baseURL}actor/staff/list`, { params }).then(
            response => response
        );
    },
    getDeactivateConfirmation(id) {
        return Axios.get(
            `${baseURL}actor/staff/deactivate/confirmation/${id}`
        ).then(response => response);
    },
    deactivate(id, data) {
        return Axios.put(`${baseURL}actor/staff/deactivate/${id}`, data).then(
            response => response
        );
    },
    reactivate(id) {
        return Axios.put(`${baseURL}actor/staff/reactivate/${id}`).then(
            response => response
        );
    },
    async getBalanceQuota() {
        const res = await Axios.get(
            `${baseURL}account/subscription/user-balance-quota`
        );
        if (res && res.data && res.data.response) {
            return res.data.response;
        }
        return null;
    },
    async getProductionCredits() {
        const res = await Axios.get(`${baseURL}account/production_credit`);
        if (
            res &&
            res.data &&
            res.data.response &&
            res.data.response.resource &&
            res.data.response.resource.data
        ) {
            return res.data.response.resource.data;
        }
        return [];
    },
    async saveNewStaff(body) {
        return Axios.post(`${baseURL}actor/staff`, {
            ...body
        }).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    async updateStaff(body) {
        return Axios.put(`${baseURL}actor/staff/${body.id}`, {
            ...body
        }).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    async getStaffDetail(id) {
        return Axios.get(`${baseURL}actor/staff/${id}?encoded=${true}`).then(
            response => response
        );
    },
    async getResetPassword(id) {
        return Axios.get(`${baseURL}actor/staff/reset-password/${id}`).then(
            response => response
        );
    },
    async saveSignature(params) {
        return Axios.post(`${baseURL}actor/staff/save-signature`, params).then(
            res => {
                if (res && res.data && res.data.response) {
                    return res.data.response;
                }
                return null;
            }
        );
    },
    async getTimesheets(staffId, page, perPage) {
        return Axios.get(`${baseURL}actor/staff/timesheet`, {
            params: {
                user_id: staffId,
                page,
                perPage
            }
        }).then(response => response.data.response);
    },
    async createTimesheet(body) {
        return Axios.post(`${baseURL}actor/staff/timesheet`, {
            ...body
        }).then(response => response.data.response);
    },
    async updateTimesheet(body) {
        return Axios.put(`${baseURL}actor/staff/timesheet/${body.id}`, {
            ...body
        }).then(response => response.data.response);
    },
    async deleteTimesheet(timesheetId) {
        return Axios.delete(
            `${baseURL}actor/staff/timesheet/${timesheetId}`
        ).then(response => response.data.response);
    },
    async savePhoto(params) {
        return Axios.post(`${baseURL}actor/staff/save-photo`, params).then(
            res => {
                if (res && res.data && res.data.response) {
                    return res.data.response;
                }
                return null;
            }
        );
    },
    async getProviderRecordSharingClinics(staffId, params = {}) {
        return Axios.get(
            `${baseURL}actor/staff/${staffId}/record-sharing-clinics`,
            {
                params: params
            }
        ).then(response => response.data.response);
    }
};
